import { Dropdown, InputGroupText, MultiSelectNew, TextField, DatePicker } from "app/components/CustomFormElements/syncFusionFormFields";
import { fundingValidationSchema } from "app/helper/validationSchema/companyValidationSchema";
import { useFormik } from "formik";
import * as Yup from "yup";
import { actionError, actionSuccess, showLoader, hideLoader } from "middleware/actions/utilityAction";
import { fetchCompany, fetchFunding, fetchSingleCompany, saveFunding, editFunding } from "middleware/services/companyApi";
import { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBreadCrumb } from "middleware/actions/breadCrumbAction";
import { useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import fundingTypeOptions from "../../../../constants";
import { getProductVariant } from "../../../../../../../utilities";
import moment from "moment";

const CompanyBasicFunding = (props) => {
  const { companyId, fundingId } = props.computedMatch.params || {};
  const [companyName, setCompanyName] = useState("");
  const [investors, setInvestors] = useState([]);
  const [investorsForEdit, setInvestorsForEdit] = useState([]);

  const [oldData, setOldData] = useState(null);
  const split_url = props.location?.pathname.split("/");

  const backPath = fundingId ? `${split_url.slice(0, -3).join("/")}/edit#basic` : `${split_url.slice(0, -2).join("/")}/edit#basic`;

  const dispatch = useDispatch();
  const history = useHistory();

  const breadCrumbLinks = [
    { linkUrl: "/company", linkName: `Company`, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: companyName, linkActive: false },
    { linkUrl: `/company/${companyId}/edit#basic`, linkName: "Basic", linkActive: false },
    { linkUrl: ``, linkName: "Funding", linkActive: true },
  ];

  const initialFormValues = {
    fundingName: "",
    fundingAmount: "",
    fundingTypeRound: "",
    fundingInvestors: [],
    fundingDate: "",
  };

  const formik = useFormik({
    initialValues: oldData || initialFormValues,
    validationSchema: Yup.object().shape(fundingValidationSchema),
    enableReinitialize: true,
  });

  const searchTag = async (value) => {
    if (value.length > 2) {
      let filters = [];
      const productVariant = getProductVariant();
      if (productVariant) filters.push(["productVariant.productName", "eq", productVariant]);
      filters.push(["companyName", "cn", value]);
      let fields = { fields: ["companyId", "companyName"] };
      const response = await fetchCompany({ filters: filters, ...fields, sort: "companyName:asc", limit: 10 });
      if (response.data && response.data.data) {
        const resData = response.data.data
          .map((v) => {
            if (!formik.values.fundingInvestors.some((investor) => investor.companyId === v.id || investor.value === v.id))
              return { label: v.companyName, value: v.id };
          })
          .filter(Boolean);
        if (resData) {
          setInvestors([...resData, ...investors]);
        } else {
          setInvestors([]);
        }
      }
    }
  };

  const getCompanyName = async () => {
    if (companyId) {
      const fields = { fields: ["id", "companyName"] };
      const response = await fetchSingleCompany(companyId, { ...fields });
      setCompanyName(response.data.data.companyName);
    }
  };

  // save a funding
  const handleSaveFunding = async () => {
    const fundingOnCompanyId = [
      {
        companyId,
        companyName: companyName,
      },
    ];

    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let payload = formik.values;
        let fundingInvestors = payload.fundingInvestors.map((c) => {
          if (c.label === c.value) {
            return { companyName: c.value };
          } else {
            return {
              companyName: c.label,
              companyId: c.value,
            };
          }
        });
        payload.fundingInvestors = fundingInvestors;
        payload.fundingOnCompanyId = fundingOnCompanyId;
        payload.fundingDate = moment(payload.fundingDate).format("DD-MMM-yyyy");
        payload.fundingAmount = payload.fundingAmount == "NA" ? payload.fundingAmount : +payload.fundingAmount;
        saveFunding(payload)
          .then((response) => {
            dispatch(hideLoader());
            dispatch(actionSuccess("Funding Added Successfully"));
            history.push(backPath);
          })
          .catch((err) => {
            dispatch(hideLoader());
            dispatch(actionError(err?.data?.message || "Something went wrong"));
          });
      }
    });
  };

  // handleEdit funding
  const handleEditFunding = async () => {
    const fundingOnCompanyId = [
      {
        companyId,
        companyName: companyName,
      },
    ];

    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
      } else {
        dispatch(showLoader());
        let payload = formik.values;
        let fundingInvestors = payload.fundingInvestors.map((c) => {
          if (Boolean(c.label) && Boolean(c.value) && c.label === c.value) {
            return { companyName: c.value };
          } else {
            return {
              companyName: c.label || c.companyName,
              companyId: c.value || c.companyId,
            };
          }
        });
        payload.fundingInvestors = fundingInvestors;
        payload.fundingOnCompanyId = fundingOnCompanyId;
        payload.fundingDate = payload.fundingDate.toString();
        payload.fundingAmount = payload.fundingAmount == "NA" ? payload.fundingAmount : +payload.fundingAmount;
        delete payload.fundingCreatedDate;
        delete payload.fundingUpdatedDate;
        delete payload.id;
        editFunding(fundingId, payload)
          .then((response) => {
            dispatch(hideLoader());
            dispatch(actionSuccess("Funding updated successfully"));
            history.push(backPath);
          })
          .catch((err) => {
            dispatch(hideLoader());
            dispatch(actionError(err.data ? err?.data?.message : "Something went wrong"));
          });
      }
    });
  };

  const setFormikValues = (data) => {
    const oldData = {
      fundingName: data.fundingName || "",
      fundingAmount: data.fundingAmount || "",
      fundingTypeRound: data.fundingTypeRound || "",
      fundingInvestors: data.fundingInvestors || [],
      fundingDate: data.fundingDate || "",
    };
    setOldData(oldData);
    setTimeout(() => {
      formik.setValues(oldData);
    }, 1);
  };

  useEffect(() => {
    if (props.editData && companyId && fundingId) {
      formik.resetForm();
      fetchFunding(companyId)
        .then((res) => {
          let fundingData = res.data?.data?.filter((e) => e.id === fundingId)?.[0] || {};
          let investorsEdit = fundingData?.fundingInvestors?.map((company) => {
            return { label: company?.companyName, value: company?.companyId || company?.companyName };
          });
          fundingData.fundingInvestors = investorsEdit;
          setInvestorsForEdit(investorsEdit);
          setFormikValues(fundingData);
        })
        .catch((err) => {
          dispatch(actionError(err?.data?.message || "Something went wrong"));
        });
    } else {
      formik.resetForm();
    }
  }, [props.editData, companyId, fundingId]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadCrumbLinks));
  }, [breadCrumbLinks]);

  useEffect(() => {
    getCompanyName();
  }, [companyId]);

  return (
    <div className="p-0 m-3 company-basic-modal">
      <div className="modal-header">Company - Funding</div>
      <div className="modal-body">
        <div className="row pl-3 pt-3 pr-3">
          <div className="col-md-4">
            <div className="form-group">
              <TextField
                formik={formik}
                className="form-control"
                id="fundingName"
                name="fundingName"
                placeholder="Transaction Name *"
                required="required"
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <DatePicker
                formik={formik}
                properties={{
                  placeholder: "Transaction Date *",
                  id: `fundingDate`,
                  name: `fundingDate`,
                  format: "dd MMM yyyy",
                  floatLabelType: "Auto",
                  allowEdit: false,
                  openOnFocus: true,
                }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <TextField
                formik={formik}
                className="form-control"
                id="fundingAmount"
                name="fundingAmount"
                placeholder="Amount(Million USD) *"
                required="required"
              />
              <ReactTooltip />
            </div>
          </div>
        </div>
        <div className="row pl-3 pr-3">
          <div className="col-md-4">
            <div className="form-group">
              <Dropdown
                formik={formik}
                id="fundingTypeRound"
                name="fundingTypeRound"
                placeholder="Funding Type *"
                dataSource={fundingTypeOptions}
                fields={{ text: "label", value: "value" }}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <MultiSelectNew
                formik={formik}
                mode="Box"
                allowCustomValue={true}
                allowFiltering={true}
                placeholder="Investors *"
                id="fundingInvestors"
                name="fundingInvestors"
                value={investorsForEdit.map((v) => {
                  return v.label;
                })}
                fields={{ text: "label", value: "value" }}
                filtering={(e) => {
                  searchTag(e.text);
                }}
                noRecordsTemplate={() => <div className="norecord">Type min 3 characters to search investors</div>}
                dataSource={investors}
              />
            </div>
          </div>
        </div>

        <div className="text-right border-top p-3 mt-auto">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              history.push(backPath);
            }}
            className="btn btn-outline-dark mr-3"
          >
            Cancel
          </button>

          {true ? (
            <button type="button" className="btn btn-primary" onClick={props.editData ? handleEditFunding : handleSaveFunding} disabled={false}>
              {props?.editData ? "Update" : "Save"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CompanyBasicFunding;
